/* eslint-disable global-require */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { ManorContext } from '@comparethemarketau/manor-provider';

/**
 * For web component mannor library to prevent SSR issue with requiring components
 * @param {string} path - path for dynamic component
 * @returns {Node|null} returns the children or null depending on the server side rendering
 */
const DynamicComponent = memo(({ component }) => {
    if (typeof document === 'undefined') {
        return null;
    }
    return component;
});

DynamicComponent.propTypes = {
    component: PropTypes.node
};

/**
 * Returns the breakpoint by manor-provider
 * @returns {string} xs|sm|md|lg|xl
 */
const getBreakpointFromManor = () => {
    if (typeof document === 'undefined') {
        return null;
    }
    const { breakpoint } = useContext(ManorContext);
    return breakpoint;
};

export { DynamicComponent, getBreakpointFromManor };
